// extracted by mini-css-extract-plugin
export default {"inputBox":"styles_inputBox__WNSSj","input":"styles_input__4h40w","inputError":"styles_inputError__FmgtT","required":"styles_required__B2idS","nickname":"styles_nickname__EONJa"};